import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { select, Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { map, take } from 'rxjs/operators';
import * as AuthSelectors from '../../store/selectors/auth.selectors';

import { AppState } from '../../store/reducers';

@Injectable({
  providedIn: "root"
})
export class UnAuthGuard implements CanActivate {
  constructor(
    private router: Router,
    private store: Store<AppState>
  ) { }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    return this.store.pipe(
      select(AuthSelectors.getIsAuthenticated),
      take(1),
      map(authenticated => {
        if (authenticated) {
          this.router.navigate(['/']);
        }
        return !authenticated;
      })
    );
  }
}
